window.ReportingAPI = new function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['ReportingServersV1']);


    self.getJobBoardsLookup = function (jobIds, status) {
        var deferred = $q.defer();

        var params = {
            job_ids: jobIds.join(',')
        };

        if (status == "BOOST") {
            params["boost"] = 1
        }


        _protected.request(self.apiUrl.replace('v1', 'v4') + "job_boards_lookup", 'GET', params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;

    };


    self.sendBoardsPublish = function (jobIds, jobBoards, payment_method) {
        var deferred = $q.defer();
        var params = {
            job_ids: jobIds,
            boards: jobBoards,
            payment_method: payment_method,
        };

        _protected.request(self.apiUrl.replace('v1', 'v3') + "boards_publish", "PUT", params).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.trackReportingView = function (jobId, source, brandId, referrerId, mediaChannel) {
        var deferred = $q.defer();

        _protected.request(
            publicConfiguration['ReportingTrackingServers'] + "/",
            "POST",
            {
                "code": "V-C-001",
                "job_id": jobId,
                "brand_id": brandId,
                "source": source,
                "job_referrer_id": referrerId,
                "social_media_channel": mediaChannel
            })
            .then(function (data) {
                deferred.resolve(data);
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    function ucFirstAllWords(str) {
        var pieces = str.split(" ");
        for (var i = 0; i < pieces.length; i++) {
            var j = pieces[i].charAt(0).toUpperCase();
            pieces[i] = j + pieces[i].substr(1).toLowerCase();
        }
        return pieces.join(" ");
    }

    self.getSourceName = function (_source) {
        var source = _source;
        if (!self.CHANNEL_CODES[source.toUpperCase()]) {
            source = source.toLowerCase();
            if (source.indexOf("_channel") > -1 && source.indexOf("_channel") === (source.length - "_channel".length)) {
                source = source.substring(0, source.lastIndexOf("_channel"));
            }
            if (!self.CHANNEL_CODES[source.toUpperCase()]) {
                source = source.replace(/_/g, ' ');
                source = ucFirstAllWords(source);
            }
        }
        return self.CHANNEL_NAMES[self.CHANNEL_CODES[source.toUpperCase()]] || source;
    };

    self.handleSourcesWithChannel = function (source) {
        if (!self.CHANNEL_CODES[source.toUpperCase()]) {
            if (source.indexOf("_channel") > -1 && source.indexOf("_channel") === (source.length - "_channel".length)) {
                source = source.substring(0, source.lastIndexOf("_channel"));
            }
        }

        return source;
    };
};

/**
 * sourcing
 */
ReportingAPI.CHANNEL_CODES = {};

ReportingAPI.CHANNEL_CODES.INDEED = "INDEED";
ReportingAPI.CHANNEL_CODES.INDEED_APPLY = "INDEED_APPLY";
ReportingAPI.CHANNEL_CODES.INDEED_SPONSORED = "INDEED_SPONSORED";
ReportingAPI.CHANNEL_CODES.CL = "CL";
ReportingAPI.CHANNEL_CODES.GLASSDOOR_ORGANIC = "GLASSDOOR_ORGANIC";
ReportingAPI.CHANNEL_CODES.CRAIGSLIST = "CRAIGSLIST";
ReportingAPI.CHANNEL_CODES.SH = "SH";
ReportingAPI.CHANNEL_CODES.SH = "SIMPLYHIRED";
ReportingAPI.CHANNEL_CODES.HARRI = "HARRI";
ReportingAPI.CHANNEL_CODES.CATERER = "CATERER";
ReportingAPI.CHANNEL_CODES.GUMTREE = "GUMTREE";
ReportingAPI.CHANNEL_CODES.GUMTREE_FEATURED = "GUMTREE_FEATURED";
ReportingAPI.CHANNEL_CODES.LEISURE_JOBS = "LEISURE_JOBS";
ReportingAPI.CHANNEL_CODES.REED = "REED";
ReportingAPI.CHANNEL_CODES.MONSTER = "MONSTER";
ReportingAPI.CHANNEL_CODES.JOBS_2_CAREERS = "JOBS_2_CAREERS";
ReportingAPI.CHANNEL_CODES.ZIP_RECRUITER = "ZIP_RECRUITER";
ReportingAPI.CHANNEL_CODES.ZIP_RECRUITER_SPONSORED = "ZIP_RECRUITER_SPONSORED";
ReportingAPI.CHANNEL_CODES.ZIP_RECRUITER_APPLY = "ZIP_RECRUITER_APPLY";
ReportingAPI.CHANNEL_CODES.GLASSDOOR = "GLASSDOOR";
ReportingAPI.CHANNEL_CODES.JOOBLE = "JOOBLE";
ReportingAPI.CHANNEL_CODES.ADZUNA = "ADZUNA";
ReportingAPI.CHANNEL_CODES.EMPLOYER_UPLOADED = "EMPLOYER_UPLOADED";
ReportingAPI.CHANNEL_CODES['M&B_CHANNEL'] = "M&B_CHANNEL";
ReportingAPI.CHANNEL_CODES['SOCIAL_REFERRAL'] = "SOCIAL_REFERRAL";
ReportingAPI.CHANNEL_CODES.CAREER_PORTAL_SUBSCRIPTION = "CAREER_PORTAL_SUBSCRIPTION";
ReportingAPI.CHANNEL_CODES['HOSPITALITY_JOBS_CHANNEL'] = "HOSPITALITY_JOBS_CHANNEL";
ReportingAPI.CHANNEL_CODES.INTERNAL = 'INTERNAL';
ReportingAPI.CHANNEL_CODES.SNAGAJOB = 'SNAGAJOB';
ReportingAPI.CHANNEL_CODES.CAREERBUILDER = 'CAREERBUILDER';
ReportingAPI.CHANNEL_CODES.POACHED = 'POACHED';
ReportingAPI.CHANNEL_CODES.JOBS_IE = 'JOBS_IE';
ReportingAPI.CHANNEL_CODES.FINNJOBB = 'FINNJOBB';
ReportingAPI.CHANNEL_CODES.HOTELCAREER = 'HOTELCAREER';
ReportingAPI.CHANNEL_CODES.HEADHUNTER = 'HEADHUNTER';
ReportingAPI.CHANNEL_CODES.CATERERGLOBAL_UK = 'CATERERGLOBAL_UK';
ReportingAPI.CHANNEL_CODES.HOSCO_CH = 'HOSCO_CH';
ReportingAPI.CHANNEL_CODES.HOSCO_APPLY = 'HOSCO_APPLY';
ReportingAPI.CHANNEL_CODES.RETAILCHOICE = 'RETAILCHOICE';
ReportingAPI.CHANNEL_CODES.LINKEDIN = 'LINKEDIN';
ReportingAPI.CHANNEL_CODES.TOTALJOBS = 'TOTALJOBS';
ReportingAPI.CHANNEL_CODES['HCAREERS.COM'] = 'HCAREERS.COM';
ReportingAPI.CHANNEL_CODES.SUPERJOBS = 'SUPERJOBS';
ReportingAPI.CHANNEL_CODES.CULINTRO = 'CULINTRO';
ReportingAPI.CHANNEL_CODES.CULINARYAGENTS = 'CULINARYAGENTS';
ReportingAPI.CHANNEL_CODES.ALLTHETOPBANANAS = "ALLTHETOPBANANAS";
ReportingAPI.CHANNEL_CODES.JOBRAPIDO = "JOBRAPIDO";
ReportingAPI.CHANNEL_CODES.WORKCIRCLE = "WORKCIRCLE";
ReportingAPI.CHANNEL_CODES.JOBISJOB = "JOBISJOB";
ReportingAPI.CHANNEL_CODES.JOBBYDOO = "JOBBYDOO";
ReportingAPI.CHANNEL_CODES.NEUVOO = "NEUVOO";
ReportingAPI.CHANNEL_CODES.JOBG8 = "JOBG8";
ReportingAPI.CHANNEL_CODES.MYJOBHELPER = "MYJOBHELPER";
ReportingAPI.CHANNEL_CODES.JOBTOME = "JOBTOME";
ReportingAPI.CHANNEL_CODES.JORA = "JORA";
ReportingAPI.CHANNEL_CODES.ADVIEW = "ADVIEW";
ReportingAPI.CHANNEL_CODES.TROVIT = "TROVIT";
ReportingAPI.CHANNEL_CODES.JOBLIFT = "JOBLIFT";
ReportingAPI.CHANNEL_CODES.MYJOBMATCHER = "MYJOBMATCHER";
ReportingAPI.CHANNEL_CODES.TWITTER = "TWITTER";
ReportingAPI.CHANNEL_CODES.YOUTUBE = "YOUTUBE";
ReportingAPI.CHANNEL_CODES.INSTAGRAM = "INSTAGRAM";
ReportingAPI.CHANNEL_CODES.EJOBS = "EJOBS";
ReportingAPI.CHANNEL_CODES.TURIJOBS = "TURIJOBS";
ReportingAPI.CHANNEL_CODES.JOBINDEX = "JOBINDEX";
ReportingAPI.CHANNEL_CODES.PLATSBANKEN = "PLATSBANKEN";
ReportingAPI.CHANNEL_CODES.ARBETSFORMEDLINGEN = "ARBETSFORMEDLINGEN";
ReportingAPI.CHANNEL_CODES.APPLEBEES = "APPLEBEES";
ReportingAPI.CHANNEL_CODES.KARIYER_NET = "KARIYER_NET";
ReportingAPI.CHANNEL_CODES.HOSPITALITY_JOB_UK = "HOSPITALITY_JOB_UK";
ReportingAPI.CHANNEL_CODES.GOOGLE_JOBS_APPLY = "GOOGLE_JOBS_APPLY";
ReportingAPI.CHANNEL_CODES.ATSI_APPLY = "ATSI_APPLY";
ReportingAPI.CHANNEL_CODES.TALENT = "TALENT";
ReportingAPI.CHANNEL_CODES.JOBNET_DK = "JOBNET_DK";
ReportingAPI.CHANNEL_CODES.FACEBOOK_APPLY = "FACEBOOK_APPLY";
ReportingAPI.CHANNEL_CODES.DUNKIN = "DUNKIN";
ReportingAPI.CHANNEL_CODES.FUSED7 = "FUSED7";
ReportingAPI.CHANNEL_CODES.TALROO = "TALROO";
ReportingAPI.CHANNEL_CODES.RESTLESS_CHANNEL = "RESTLESS_CHANNEL";
ReportingAPI.CHANNEL_CODES.CV_LIBRARY = "CV_LIBRARY";

ReportingAPI.CHANNEL_NAMES = {};
ReportingAPI.CHANNEL_NAMES.INDEED = "Indeed";
ReportingAPI.CHANNEL_NAMES.INDEED_APPLY = "Indeed Apply";
ReportingAPI.CHANNEL_NAMES.INDEED_SPONSORED = "Indeed Sponsored";
ReportingAPI.CHANNEL_NAMES.CL = "Craigslist";
ReportingAPI.CHANNEL_NAMES.CRAIGSLIST = "Craigslist";
ReportingAPI.CHANNEL_NAMES.SH = "SimplyHired";
ReportingAPI.CHANNEL_NAMES.SIMPLYHIRED = "SimplyHired";
ReportingAPI.CHANNEL_NAMES.HARRI = "Harri";
ReportingAPI.CHANNEL_NAMES.CATERER = "Caterer";
ReportingAPI.CHANNEL_NAMES.GUMTREE = "Gumtree";
ReportingAPI.CHANNEL_NAMES.GUMTREE_FEATURED = "GumTree Featured";
ReportingAPI.CHANNEL_NAMES.LEISURE_JOBS = "LeisureJobs";
ReportingAPI.CHANNEL_NAMES.REED = "Reed";
ReportingAPI.CHANNEL_NAMES.MONSTER = "Monster";
ReportingAPI.CHANNEL_NAMES.JOBS_2_CAREERS = "Jobs2Careers";
ReportingAPI.CHANNEL_NAMES.ZIP_RECRUITER = "ZipRecruiter";
ReportingAPI.CHANNEL_NAMES.ZIPRECRUITER = "ZipRecruiter";
ReportingAPI.CHANNEL_NAMES.ZIP_RECRUITER_SPONSORED = "ZipRecruiter Sponsored";
ReportingAPI.CHANNEL_NAMES.ZIP_RECRUITER_APPLY = "ZipRecruiter Apply";
ReportingAPI.CHANNEL_NAMES.GLASSDOOR_ORGANIC = "Glassdoor Free";
ReportingAPI.CHANNEL_NAMES.GLASSDOOR = "Glassdoor";
ReportingAPI.CHANNEL_NAMES.JOOBLE = "Jooble";
ReportingAPI.CHANNEL_NAMES.ADZUNA = "Adzuna";
ReportingAPI.CHANNEL_NAMES.FACEBOOK = "Facebook";
ReportingAPI.CHANNEL_NAMES.FACEBOOK_APPLY = "Facebook Apply";
ReportingAPI.CHANNEL_NAMES.DUNKIN = "Dunkin";
ReportingAPI.CHANNEL_NAMES.FUSED7 = "Fused7 for Swingers";
ReportingAPI.CHANNEL_NAMES.TALROO = "Talroo";
ReportingAPI.CHANNEL_NAMES.RESTLESS_CHANNEL = "RestLess";
ReportingAPI.CHANNEL_NAMES.EMPLOYER_UPLOADED = $filter("translate")("uploaded");
ReportingAPI.CHANNEL_NAMES['M&B_CHANNEL'] = "Click IQ";
ReportingAPI.CHANNEL_NAMES['SOCIAL_REFERRAL'] = "Employee Referral";
ReportingAPI.CHANNEL_NAMES.CAREER_PORTAL_SUBSCRIPTION = "Job Alerts";
ReportingAPI.CHANNEL_NAMES['HOSPITALITY_JOBS_CHANNEL'] = "HospitalityJobs";
ReportingAPI.CHANNEL_NAMES.INTERNAL = $filter("translate")('Internal');
ReportingAPI.CHANNEL_NAMES.SNAGAJOB = 'Snagajob';
ReportingAPI.CHANNEL_NAMES.CAREERBUILDER = 'CareerBuilder';
ReportingAPI.CHANNEL_NAMES.POACHED = 'Poached';
ReportingAPI.CHANNEL_NAMES.JOBS_IE = 'Jobs.ie';
ReportingAPI.CHANNEL_NAMES.FINNJOBB = 'Finn Jobs';
ReportingAPI.CHANNEL_NAMES.HOTELCAREER = 'HotelCareer';
ReportingAPI.CHANNEL_NAMES.HEADHUNTER = 'Headhunter';
ReportingAPI.CHANNEL_NAMES.CATERERGLOBAL_UK = 'CatererGlobal';
ReportingAPI.CHANNEL_NAMES.HOSCO_CH = 'hosco';
ReportingAPI.CHANNEL_NAMES.HOSCO_APPLY = 'hosco';
ReportingAPI.CHANNEL_NAMES.RETAILCHOICE = 'RetailChoice';
ReportingAPI.CHANNEL_NAMES.LINKEDIN = 'LinkedIn';
ReportingAPI.CHANNEL_NAMES.TOTALJOBS = 'TotalJobs';
ReportingAPI.CHANNEL_NAMES['HCAREERS.COM']  = 'HCareers';
ReportingAPI.CHANNEL_NAMES.SUPERJOBS = 'Superjob';
ReportingAPI.CHANNEL_NAMES.CULINTRO = 'Culintro';
ReportingAPI.CHANNEL_NAMES.CULINARYAGENTS = 'Culinary Agents';
ReportingAPI.CHANNEL_NAMES.GOOGLE_JOBS_APPLY = 'Google Jobs';
ReportingAPI.CHANNEL_NAMES.ALLTHETOPBANANAS = "AllTheTopBananas";
ReportingAPI.CHANNEL_NAMES.JOBRAPIDO = "Jobrapido";
ReportingAPI.CHANNEL_NAMES.WORKCIRCLE = "Workcircle";
ReportingAPI.CHANNEL_NAMES.JOBISJOB = "JobIsJob";
ReportingAPI.CHANNEL_NAMES.JOBBYDOO = "JobbyDoo";
ReportingAPI.CHANNEL_NAMES.NEUVOO = "Neuvoo";
ReportingAPI.CHANNEL_NAMES.JOBG8 = "JobG8";
ReportingAPI.CHANNEL_NAMES.MYJOBHELPER = "MyJobHelper";
ReportingAPI.CHANNEL_NAMES.JOBTOME = "JobToMe";
ReportingAPI.CHANNEL_NAMES.JORA = "Jora";
ReportingAPI.CHANNEL_NAMES.ADVIEW = "Adview";
ReportingAPI.CHANNEL_NAMES.TROVIT = "Trovit";
ReportingAPI.CHANNEL_NAMES.JOBLIFT = "JobLift";
ReportingAPI.CHANNEL_NAMES.MYJOBMATCHER = "MyJobMatcher";
ReportingAPI.CHANNEL_NAMES.TWITTER = "Twitter";
ReportingAPI.CHANNEL_NAMES.YOUTUBE = "Youtube";
ReportingAPI.CHANNEL_NAMES.INSTAGRAM = "Instagram";
ReportingAPI.CHANNEL_NAMES.EJOBS = "Ejobs";
ReportingAPI.CHANNEL_NAMES.TURIJOBS = "TuriJobs";
ReportingAPI.CHANNEL_NAMES.JOBINDEX = "Jobindex";
ReportingAPI.CHANNEL_NAMES.PLATSBANKEN = "Platsbanken";
ReportingAPI.CHANNEL_NAMES.APPLEBEES = "Applebee’s";
ReportingAPI.CHANNEL_NAMES.KARIYER_NET = "Kariyer.net";
ReportingAPI.CHANNEL_NAMES.HOSPITALITY_JOB_UK = "Hospitality Jobs UK";
ReportingAPI.CHANNEL_NAMES.ATSI_APPLY = "Caterer";
ReportingAPI.CHANNEL_NAMES.TALENT = "Talent";
ReportingAPI.CHANNEL_NAMES.JOBNET_DK = "Jobnet";
ReportingAPI.CHANNEL_NAMES.CV_LIBRARY = "CV Library";



